import { Button, Typography } from "@mui/material";
import dayjs from "dayjs";
import React, { useContext, useEffect, useState, useRef, useCallback } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import candidate from "../../../src/assets/Images/candidate.png";
import timesheet from "../../../src/assets/Images/timesheet.png";
import { UserManagentCheck } from "../../common/UserManagement";
import { EmployeeDataContext } from "../../customHooks/dataProviders/EmployeeDataProvider";
import { GetAllDesignations } from "../../service/api/DesinationService";
import {
  GetEmployeeLeaveByApproverId,
  GetEmployeeLeaveConfigDetails,
} from "../../service/api/emsService/EmployeeLeaveService";
import {
  GetAllByEmpId,
  GetBirthdayList,
  GetEmployeeCounts,
} from "../../service/api/emsService/EmployeeService";
import { GetAllNews } from "../../service/api/emsService/NewsService";
import { DownloadResponseFile } from "../../service/api/emsService/Payroll";
import { RemoveBillUrl, UploadExpense } from "../../service/api/ExpenseService";
import { GetAllHolidays } from "../../service/api/HolidayService";
import { GetAllWorkLocation, SendSOWDetailsEmail } from "../../service/api/hrConfig/hrConfig";
import { GetAllEvents, GetEventImages } from "../../service/api/emsService/EventsService";
import ManagerDetailsModal from "../ManagerDetailsModal/ManagerDetailsModal";
import ProfilePic from "../ProfilePic/ProfilePic";
import "./Dashbord.css";
import { approverConfigMasterData } from "../hrConfig/EmployeeApprovalConfig/ApprovalConfig";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';


// Component definition
function Dashboard() {
  const { user } = useOutletContext();
  const { employeeData, setEmployeeData } = useContext(EmployeeDataContext);
  const [designationsData, setDesignationsData] = useState(null);
  const [leaveDetails, setLeaveDetails] = useState(null);
  const [leaveApproval, setLeaveApproval] = useState(null);
  const [holidayList, setholidayList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [designation, setDesignation] = useState(null);
  const [news, setNews] = useState([]);
  const [workLocationData, setWorkLocationData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [birthdayList, setBirthdayList] = useState(null);
  const [profilePic, setProfilePic] = useState(null);
  const [employeeCounts, setEmployeeCounts] = useState({
    activeCount: 0,
    inactiveCount: 0,
  });
  const [sowEmailLoading, setSowEmailLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const [selectedEventImages, setSelectedEventImages] = useState([]);
  const [showImageModal, setShowImageModal] = useState(false);
  const [loadingImages, setLoadingImages] = useState(false);
  const [eventPage, setEventPage] = useState(0);
  const [hasMoreEvents, setHasMoreEvents] = useState(true);
  const [isFetchingEvents, setIsFetchingEvents] = useState(false);
  const eventListRef = useRef(null);
  const navigate = useNavigate();

  // ...existing code...
  const handleNavigateToApp2 = () => {
    const token = localStorage.getItem("jwtToken");
    const email = localStorage.getItem("userMailId");
    const roleNames = JSON.parse(localStorage.getItem("roleNames") || "[]");
    console.log("Roles from local storage:", roleNames);

    if (!token || !email || !roleNames.length) {
      console.error("Missing JWT token, email, or role names");
      return;
    }

    // Open App2 in a new tab/window
    const app2Window = window.open(
      "https://prod.sigmasoftinfotech.com/appregistry/",
      "_blank"
    );

    if (!app2Window) {
      console.error("Failed to open App2 window");
      return;
    }

    const targetOrigin = "https://prod.sigmasoftinfotech.com"; // exact origin of App2
    const messageId = Date.now(); // unique id to match ACK
    const authMessage = {
      type: "AUTH_DATA",
      auth_token: token,
      email,
      roleNames,
      id: messageId,
    };

    // Safe send wrapper
    const sendAuth = (target = app2Window, origin = targetOrigin) => {
      try {
        target.postMessage(authMessage, origin);
        console.log("➡️ Sent AUTH_DATA to App2", authMessage);
      } catch (err) {
        console.warn("postMessage error (will retry):", err);
      }
    };

    // Keep sending until we receive an ACK from App2 (or timeout)
    const interval = setInterval(() => sendAuth(), 250);

    // Listen for messages from App2 (REQUEST_AUTH_DATA and AUTH_ACK)
    const messageHandler = (event) => {
      console.log("Dashboard ← message", { origin: event.origin, data: event.data });

      // In production require exact origin match
      if (event.origin !== targetOrigin) return;

      const data = event.data || {};

      if (data.type === "REQUEST_AUTH_DATA") {
        // App2 asked for auth — reply immediately to the provided source
        console.log("Received REQUEST_AUTH_DATA from App2 — replying");
        try {
          // Prefer event.source.postMessage so message goes to correct window
          (event.source || app2Window)?.postMessage(authMessage, event.origin);
        } catch (err) {
          console.warn("Failed event.source.postMessage, fallback to app2Window.postMessage", err);
          app2Window.postMessage(authMessage, targetOrigin);
        }
        return;
      }

      if (data.type === "AUTH_ACK" && data.id === messageId) {
        clearInterval(interval);
        window.removeEventListener("message", messageHandler);
        console.log("✅ Received AUTH_ACK from App2 — stopped retries");
      }
    };

    window.addEventListener("message", messageHandler);

    // Fallback: stop retries after 8s
    const timeout = setTimeout(() => {
      clearInterval(interval);
      window.removeEventListener("message", messageHandler);
      console.warn("Stopped trying to send auth data after 8 seconds");
    }, 8000);

    // initial send immediately (don't wait for first interval)
    sendAuth();

    // No explicit cleanup here because the user may navigate — listeners/timeouts are removed
    // when ACK received or when timeout fires above.
  };
  // ...existing code...

  // Other variables and user permissions
  const candidateList = UserManagentCheck("hr_tools_smartHire_candidateList");
  const hr = UserManagentCheck(
    "hr_tools_smartHire_candidate_approval_uploadOfferLetter"
  );
  const sowEmailPermission = UserManagentCheck("hr_tools_sow_emailSOWDetails");
  const budget = UserManagentCheck(
    "hr_tools_smartHire_candidate_approval_budgetApproval"
  );
  const management = UserManagentCheck(
    "hr_tools_smartHire_candidate_approval_managementApproval"
  );

  const leaveApprover = UserManagentCheck("hr_tools_ems_leave_leaveApproval");

  const appRegistry =
    UserManagentCheck("ar_admin") || UserManagentCheck("ar_user");

  const genericUser = employeeData?.genericProfile;

  // Navigating to different pages
  const handleTimesheetNavigate = () => {
    navigate("/home/ems/timesheet");
  };

  const handleCandidateNavigate = () => {
    navigate("/home/smartHire/candidateList");
  };

  const handleLeaveApprovalsNavigate = () => {
    navigate("/home/ems/leave");
  };

  const handleHolidayNavigate = () => {
    navigate("/home/tools/holidays");
  };

  const handleActiveEmployeesNavigate = () => {
    navigate("/home/details/employee_status/active");
  };

  const handleInactiveEmployeesNavigate = () => {
    navigate("/home/details/employee_status/inactive");
  };

  const getNextHoliday = (holidays) => {
    const todayDate = dayjs().startOf("day");
    const upcomingHolidays = holidays
      .filter(
        (holiday) =>
          dayjs(holiday.holidayDate).isSame(todayDate) ||
          dayjs(holiday.holidayDate).isAfter(todayDate)
      )
      .sort((a, b) => dayjs(a.holidayDate).diff(dayjs(b.holidayDate)));
    return upcomingHolidays[0];
  };

  const handleOpenModal = (type) => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  // useEffect hook for fetching initial data
  useEffect(() => {
    const fetchData = async () => {
      if (!employeeData?.employeeBasicDetailId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        const [
          designationsResult,
          workLocationResult,
          employeeDetails,
          leaveResult,
          birthdaysResult,
          holidaysResult,
          newsResult,
          leaveApprovalResult,
          employeeCounts
        ] = await Promise.allSettled([
          GetAllDesignations(),
          GetAllWorkLocation(),
          GetAllByEmpId({ employeeBasicDetailId: employeeData.employeeBasicDetailId }),
          GetEmployeeLeaveConfigDetails({ employeeId: employeeData.employeeBasicDetailId }),
          GetBirthdayList(),
          GetAllHolidays({ workLocation: employeeData.workLocationCode }),
          GetAllNews(),
          GetEmployeeLeaveByApproverId(employeeData.employeeBasicDetailId),
          GetEmployeeCounts()
        ]);

        // Process Designations
        const designations = designationsResult.status === 'fulfilled' && Array.isArray(designationsResult.value) ? designationsResult.value : [];
        setDesignationsData(designations);
        if (employeeData.designation) {
          const des = designations.find(d => d.designationCode === employeeData.designation);
          setDesignation(des?.designationDescription || "Not Available");
        }

        // Process Work Location
        const locations = workLocationResult.status === 'fulfilled' && Array.isArray(workLocationResult.value) ? workLocationResult.value : [];
        if (employeeData.workLocationCode) {
          const loc = locations.find(w => w.workLocationCode === employeeData.workLocationCode);
          setWorkLocationData(loc?.workLocation || "Not Available");
        }

        // Process Approver Config (Table Data)
        const details = employeeDetails.status === 'fulfilled' && Array.isArray(employeeDetails.value) ? employeeDetails.value : [];
        const formattedTableData = details.map((detail) => {
          const { moduleName, approverEntity } = detail;
          const approverName = approverEntity
            ? `${approverEntity.firstName} ${approverEntity.lastName}`
            : "N/A";
          return {
            moduleName: approverConfigMasterData.find(a => a.moduleCode === moduleName)?.module || moduleName,
            approverName,
          };
        });
        setTableData(formattedTableData);

        // Process Leave Balance
        const leaves = leaveResult.status === 'fulfilled' && Array.isArray(leaveResult.value) ? leaveResult.value : [];
        let leaveData = { leaveBalance: 0, leaveTakenThisYear: 0, pendingLeaveRequests: 0 };
        for (const leave of leaves) {
          leaveData.leaveBalance += Math.abs(leave.remaining || 0);
          leaveData.leaveTakenThisYear += Math.abs(leave.used || 0);
          leaveData.pendingLeaveRequests += Math.abs(leave.pending || 0);
        }
        setLeaveDetails(leaveData);

        // Process Birthdays
        const birthdays = birthdaysResult.status === 'fulfilled' && Array.isArray(birthdaysResult.value) ? birthdaysResult.value : [];
        const sortedBirthdays = [...birthdays].sort((a, b) => {
          const currentYear = new Date().getFullYear();
          const dateA = new Date(a.dob);
          const dateB = new Date(b.dob);
          dateA.setFullYear(currentYear);
          dateB.setFullYear(currentYear);
          return dateA - dateB;
        });
        setBirthdayList(sortedBirthdays);

        // Process Holidays
        const holidays = holidaysResult.status === 'fulfilled' && Array.isArray(holidaysResult.value) ? holidaysResult.value : [];
        const nextHoliday = getNextHoliday(holidays);
        setholidayList(nextHoliday ? [nextHoliday] : []);

        // Process News
        setNews(newsResult.status === 'fulfilled' && Array.isArray(newsResult.value) ? newsResult.value : []);

        // Process Leave Approvals
        setLeaveApproval(leaveApprovalResult.status === 'fulfilled' && Array.isArray(leaveApprovalResult.value) ? leaveApprovalResult.value : []);

        // Process Employee Counts
        if (employeeCounts.status === 'fulfilled' && employeeCounts.value) {
          setEmployeeCounts(employeeCounts.value);
        }

        setLoading(false);
      } catch (error) {
        console.error("Error in Dashboard fetchData:", error);
        setLoading(false);
      }
    };

    const fetchProfilePic = async () => {
      if (employeeData?.profilePicPath) {
        try {
          // Fetch image using the path from employee data
          const imagePath = employeeData?.profilePicPath;
          const imageBlob = await DownloadResponseFile(imagePath); // Call the API to fetch image

          // Create a URL for the image blob and update state
          const imageURL = URL.createObjectURL(imageBlob);
          setProfilePic(imageURL);
        } catch (error) {
          console.error("Error fetching profile picture:", error);
        }
      }
    };

    if (employeeData) {
      fetchProfilePic(); // Fetch profile picture if employeeData exists
    }

    fetchData(); // Fetch the rest of the data
  }, [employeeData]); // Re-run the effect if employeeData changes

  const fetchEvents = useCallback(async (page) => {
    if (isFetchingEvents || !hasMoreEvents) return;

    try {
      setIsFetchingEvents(true);
      const result = await GetAllEvents(page, 10);
      if (result && result.content) {
        setEvents((prev) => (page === 0 ? result.content : [...prev, ...result.content]));
        setHasMoreEvents(!result.last);
        setEventPage(page + 1);
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      setIsFetchingEvents(false);
    }
  }, [isFetchingEvents, hasMoreEvents]);

  useEffect(() => {
    if (employeeData) {
      fetchEvents(0);
    }
  }, [employeeData]);

  const handleScroll = useCallback(() => {
    if (!eventListRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = eventListRef.current;
    if (scrollHeight - scrollTop <= clientHeight + 50) {
      fetchEvents(eventPage);
    }
  }, [fetchEvents, eventPage]);

  useEffect(() => {
    const listElement = eventListRef.current;
    if (listElement) {
      listElement.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (listElement) {
        listElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  const handleImageSelect = async (file) => {
    // Create FormData to send the image to the backend
    const formData = new FormData();
    formData.append("file", file);
    console.log(formData);
    const type = "profilePic";

    try {
      const response = await UploadExpense(
        formData,
        employeeData?.employeeCode,
        type
      );
      if (response?.imageUrl) {
        setProfilePic(response.imageUrl); // Update profile pic after successful upload
      } else {
        console.error("Error uploading profile picture");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleRemoveImage = async () => {
    try {
      const response = await RemoveBillUrl(employeeData?.employeeCode);
      if (response) {
        setProfilePic(null);
      } else {
        console.error("Error removing profile picture");
      }
    } catch (error) {
      console.error("Error removing profile picture:", error);
    }
  };

  const handleEventClick = async (eventId) => {
    try {
      setLoadingImages(true);
      setShowImageModal(true);
      const images = await GetEventImages(eventId);
      setSelectedEventImages(images);
    } catch (error) {
      console.error("Error fetching event images:", error);
    } finally {
      setLoadingImages(false);
    }
  };

  const handleCloseImageModal = () => {
    setShowImageModal(false);
    setSelectedEventImages([]);
  };

  const handleEmailSOWDetails = async () => {
    if (sowEmailLoading) return; // Prevent multiple submissions

    try {
      setSowEmailLoading(true);

      const response = await SendSOWDetailsEmail({
        employeeId: employeeData?.employeeBasicDetailId,
        employeeEmail: employeeData?.emailId,
      });

      if (response) {
        alert(
          "SOW details email sent successfully to " + employeeData?.emailId
        );
      }
    } catch (error) {
      console.error("Error sending SOW details:", error);
      alert("Error sending SOW details email: " + (error?.message || error));
    } finally {
      setSowEmailLoading(false);
    }
  };
  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="dashboard-container p-1">
      <div className="grid-container grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Left Column */}
        <div>
          <div className="card-large bg-gradient-to-r from-[#d84759] to-[#5410bf] text-white relative">
            <div className="employee-heading">
              <Typography variant="h4" className="primary">
                {employeeData?.workType === "permanent"
                  ? "Employee / Associate Details"
                  : "Contract Employee / Associate Details"}
              </Typography>
            </div>
            <div className="employee-card">
              <div className="employee">
                <div className="mt-4">
                  {employeeData ? (
                    <div className="employee-details">
                      {!genericUser && (
                        <div className="detail-item">
                          <Typography variant="h5" className="label">
                            Employee Code: {employeeData?.employeeCode}
                          </Typography>
                        </div>
                      )}

                      <div className="detail-item">
                        <Typography variant="h5" className="label">
                          Name: {employeeData?.fullName}
                        </Typography>
                      </div>

                      <div className="detail-item">
                        <Typography variant="h5" className="label">
                          Email: {employeeData?.emailId}
                        </Typography>
                      </div>
                      {!genericUser && (
                        <div className="detail-item">
                          <Typography variant="h5" className="label">
                            Designation: {designation}
                          </Typography>
                        </div>
                      )}
                      {!genericUser && (
                        <div className="detail-item">
                          <Typography variant="h5" className="label">
                            Work Location: {workLocationData}
                          </Typography>
                        </div>
                      )}
                    </div>
                  ) : (
                    <Typography variant="body1">
                      Loading employee data...
                    </Typography>
                  )}
                </div>

                {!genericUser && (
                  <div className="button-container mt-4">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleOpenModal}
                    >
                      Manager Details
                    </Button>
                  </div>
                )}
                {sowEmailPermission && (
                  <div className="button-container mt-4">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleEmailSOWDetails}
                      disabled={sowEmailLoading}
                    >
                      {sowEmailLoading ? "Sending..." : "Email SOW Details"}
                    </Button>
                  </div>
                )}

                {appRegistry && (
                  <div className="button-container mt-4">
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleNavigateToApp2}
                    >
                      Sigmasoft's Tool Kit
                    </Button>
                  </div>
                )}
              </div>

              {/* Profile Picture inside the large card */}
              <div className="profile">
                <ProfilePic
                  profilePic={profilePic}
                  setProfilePic={setProfilePic}
                  onImageSelect={handleImageSelect}
                  onRemoveImage={handleRemoveImage}
                />
              </div>
            </div>
          </div>

          {hr && (
            <div className="employee-count grid grid-cols-1 sm:grid-cols-2 gap-4">
              {/* Active Employees Card */}
              <div
                className="card-tall bg-white p-4 rounded-lg shadow-md  quick-link-2"
                onClick={handleActiveEmployeesNavigate}
              >
                <div className="quick-link-content flex flex-col items-center text-center">
                  <Typography variant="h4" className="secondary">
                    Active Employees
                  </Typography>
                  {/* Show Active Employee Count */}
                  <Typography variant="h3" className="tertiary mt-2">
                    {employeeCounts.activeCount}
                  </Typography>
                </div>
              </div>

              {/* Inactive Employees Card */}
              <div
                className="card-tall bg-white p-4 rounded-lg shadow-md quick-link-2"
                onClick={handleInactiveEmployeesNavigate}
              >
                <div className="quick-link-content flex flex-col items-center text-center">
                  <Typography variant="h4" className="secondary">
                    Inactive Employees
                  </Typography>
                  {/* Show Inactive Employee Count */}
                  <Typography variant="h3" className="tertiary mt-2">
                    {employeeCounts.inactiveCount}
                  </Typography>
                </div>
              </div>
            </div>
          )}

          {/* Leave Details - only for permanent employees */}
          {employeeData?.workType === "permanent" &&
            leaveDetails &&
            !genericUser && (
              <div
                className="card-medium bg-white shadow-lg rounded-xl mt-4 quick-link-2"
                onClick={handleLeaveApprovalsNavigate}
              >
                <Typography variant="h4" className="secondary">
                  Leave Details
                </Typography>
                <div className="leave-details-container">
                  <div className="column-item">
                    <Typography variant="h5" className="secondary">
                      Total
                    </Typography>
                    <Typography variant="h6" className="number">
                      {leaveDetails.leaveBalance}
                    </Typography>
                  </div>
                  <div className="vertical-divider"></div>
                  <div className="column-item">
                    <Typography variant="h5" className="secondary">
                      Used
                    </Typography>
                    <Typography variant="h6" className="number">
                      {leaveDetails.leaveTakenThisYear}
                    </Typography>
                  </div>
                  <div className="vertical-divider"></div>
                  <div className="column-item">
                    <Typography variant="h5" className="secondary">
                      Pending
                    </Typography>
                    <Typography variant="h6" className="number">
                      {leaveDetails.pendingLeaveRequests}
                    </Typography>
                  </div>
                </div>
              </div>
            )}

          {/* Next Holiday - only for permanent employees */}
          {employeeData?.workType === "permanent" && (
            <div
              className="card-small bg-white shadow-lg rounded-xl mt-4 quick-link-2"
              onClick={handleHolidayNavigate}
            >
              <Typography variant="h4" className="secondary">
                Upcoming Holidays
              </Typography>
              {holidayList?.length > 0 ? (
                <>
                  <Typography variant="h6" className="tertiary">
                    {holidayList[0].holidayDescription}
                  </Typography>
                  <Typography variant="body1" className="tertiary">
                    {dayjs(holidayList[0].holidayDate).format("DD MMMM")}
                  </Typography>
                </>
              ) : (
                <Typography variant="body1" className="tertiary">
                  No upcoming holidays
                </Typography>
              )}
            </div>
          )}
        </div>

        {/* Right Column */}
        <div>
          {/* Quick Links - Both Cards Stack on Small Screens */}
          {candidateList ? (
            genericUser ? (
              // Case: Generic user and candidate list is true
              <div className="quick-links-row grid grid-cols-1 gap-4">
                <div
                  className="card-tall quick-link"
                  onClick={handleCandidateNavigate}
                >
                  <div className="quick-link-content">
                    <div className="quick-link-text">
                      <Typography variant="h4" className="secondary">
                        {hr
                          ? "Candidate List"
                          : budget || management
                            ? "Candidate Approval"
                            : ""}
                      </Typography>
                    </div>
                    <img
                      src={candidate}
                      alt="Candidate Icon"
                      className="image-class"
                    />
                  </div>
                </div>
              </div>
            ) : (
              // Case: Not a generic user but candidate list is true
              <div className="quick-links-row grid grid-cols-1 sm:grid-cols-2 gap-4">
                {/* Timesheet card hidden for genericUser */}
                {!genericUser && (
                  <div
                    className="card-small quick-link"
                    onClick={handleTimesheetNavigate}
                  >
                    <div className="quick-link-content">
                      <div className="quick-link-text">
                        <Typography variant="h4" className="secondary">
                          Timesheet
                        </Typography>
                      </div>
                      <img
                        src={timesheet}
                        alt="Timesheet Icon"
                        className="image-class"
                      />
                    </div>
                  </div>
                )}
                <div
                  className="card-small quick-link"
                  onClick={handleCandidateNavigate}
                >
                  <div className="quick-link-content">
                    <div className="quick-link-text">
                      <Typography variant="h4" className="secondary">
                        {hr
                          ? "Candidate List"
                          : budget || management
                            ? "Candidate Approval"
                            : ""}
                      </Typography>
                    </div>
                    <img
                      src={candidate}
                      alt="Candidate Icon"
                      className="image-class"
                    />
                  </div>
                </div>
              </div>
            )
          ) : (
            // Case: Candidate list is false
            // Hide the "Timesheet" card for genericUser here as well
            !genericUser && (
              <div
                className="card-tall quick-link"
                onClick={handleTimesheetNavigate}
              >
                <div className="quick-link-content">
                  <div className="quick-link-text">
                    <Typography variant="h4" className="secondary">
                      Timesheet
                    </Typography>
                  </div>
                  <img
                    src={timesheet}
                    alt="Timesheet Icon"
                    className="image-class"
                  />
                </div>
              </div>
            )
          )}

          <div>
            {leaveApprover && !employeeData?.genericProfile && (
              <div
                className="card-wide bg-white shadow-lg rounded-lg mt-4 p-6 quick-link-2"
                onClick={handleLeaveApprovalsNavigate}
              >
                <>
                  <Typography variant="h4" className="secondary text-lg">
                    Leave Approvals
                  </Typography>

                  <div className="leave-list">
                    {/* Enable scroll but hide scrollbar */}
                    {leaveApproval.length > 0 ? (
                      leaveApproval.map((leave, index) => (
                        <div
                          className="leave-item border-b py-4 flex justify-between items-center"
                          key={leave.id || index} // Changed from birthday.id to leave.id
                        >
                          <Typography
                            variant="h6"
                            className="text-gray-700 font-medium text-sm"
                          >
                            {leave.employeeName}
                          </Typography>
                          <Typography
                            variant="h6"
                            className="text-gray-700 font-medium text-sm"
                          >
                            {dayjs(leave.leaveFrom).format("D/M/YYYY")} -{" "}
                            {dayjs(leave.leaveTo).format("D/M/YYYY")}
                          </Typography>
                        </div>
                      ))
                    ) : (
                      <Typography
                        variant="body1"
                        className="text-gray-500 text-sm"
                      >
                        No leave requests pending for approval.
                      </Typography>
                    )}
                  </div>
                </>
              </div>
            )}
          </div>

          {employeeData?.workType === "permanent" && (
            <div className="card-wide bg-white shadow-lg rounded-lg mt-4 p-6">
              <Typography variant="h4" className="secondary text-lg">
                Birthday List
              </Typography>

              <div className="birthday-list max-h-56 overflow-y-auto mt-2 min-h-0">
                {/* Enable scroll but hide scrollbar */}
                {birthdayList.length > 0 ? (
                  birthdayList.map((birthday, index) => (
                    <div
                      className="birthday-item border-b py-4 flex justify-between items-center"
                      key={index}
                    >
                      <Typography
                        variant="h6"
                        className="text-gray-700 font-medium text-sm" // Reduced font size here
                      >
                        {birthday.firstName} {birthday.lastName}
                      </Typography>
                      <Typography
                        variant="h6"
                        className="text-gray-700 font-medium text-sm pr-5" // Reduced font size here
                      >
                        {dayjs(birthday.dob).format("MMMM D")}
                      </Typography>
                    </div>
                  ))
                ) : (
                  <Typography variant="body1" className="text-gray-500 text-sm">
                    No birthdays coming next week.
                  </Typography>
                )}
              </div>
            </div>
          )}

          <div className="card-wide news-section bg-white shadow-lg rounded-xl mt-4">
            <Typography variant="h4" className="secondary">
              Company News
            </Typography>

            <div className="news-list h-56 overflow-y-auto mt-2">
              {" "}
              {/* Set fixed height and scroll */}
              {news.length > 0 ? (
                news.map((item, index) => (
                  <div className="news-item border-b py-1" key={index}>
                    {" "}
                    {/* Separator */}
                    <Typography variant="body1">{item.news}</Typography>
                  </div>
                ))
              ) : (
                <Typography variant="body1" className="tertiary">
                  No news available
                </Typography>
              )}
            </div>
          </div>

          {/* Events Card */}
          <div className="card-wide bg-white shadow-lg rounded-xl mt-4 p-6 overflow-hidden">
            <Typography variant="h4" className="secondary mb-4">
              Events
            </Typography>
            <div
              className="events-list max-h-64 overflow-y-auto"
              ref={eventListRef}
            >
              {events.length > 0 ? (
                events.map((event, index) => (
                  <div
                    key={index}
                    className="event-item border-b py-3 cursor-pointer hover:bg-gray-50 flex flex-col"
                    onClick={() => handleEventClick(event.eventId)}
                  >
                    <div className="flex justify-between items-center">
                      <Typography variant="h6" className="font-bold text-gray-800">
                        {event.eventTitle}
                      </Typography>
                      <Typography variant="body2" className="text-gray-500">
                        {dayjs(event.eventDate).format("MMM DD, YYYY")}
                      </Typography>
                    </div>
                    <Typography variant="body2" className="text-gray-600 mt-1 line-clamp-2">
                      {event.eventDescription}
                    </Typography>
                  </div>
                ))
              ) : (
                <Typography variant="body1" className="text-gray-500">
                  No events available.
                </Typography>
              )}
              {isFetchingEvents && (
                <div className="text-center py-2">
                  <Typography variant="body2">Loading more...</Typography>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Event Images Modal */}
      <Modal
        open={showImageModal}
        onClose={handleCloseImageModal}
        aria-labelledby="event-images-modal"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            maxWidth: 1000,
            maxHeight: '90vh',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            outline: 'none',
            overflowY: 'auto',
          }}
        >
          <div className="flex justify-between items-center mb-4 border-b pb-2">
            <Typography variant="h5" color="primary">Event Photos</Typography>
            <IconButton onClick={handleCloseImageModal}>
              <CloseIcon />
            </IconButton>
          </div>

          {loadingImages ? (
            <div className="flex justify-center p-10">
              <Typography>Loading images...</Typography>
            </div>
          ) : selectedEventImages.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {selectedEventImages.map((imgBase64, idx) => (
                <div key={idx} className="rounded-lg overflow-hidden shadow-sm border">
                  <img
                    src={`data:image/jpeg;base64,${imgBase64}`}
                    alt={`Event image ${idx + 1}`}
                    className="w-full h-48 object-cover"
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center p-10">
              <Typography variant="body1" className="text-gray-500">No photos available for this event.</Typography>
            </div>
          )}
        </Box>
      </Modal>

      {/* Manager Details Modal */}
      <ManagerDetailsModal
        open={modalOpen}
        onClose={handleCloseModal}
        tableData={tableData}
        workType={employeeData?.workType}
      />
    </div>
  );
}

export default Dashboard;
